import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { locales } from "../../locales";
import { capitalizeWords } from "../../utils/communesUtils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  scales: {
    y: {
      grid: {
        display: false,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
      onClick: (e) => e.stopPropagation(),
    },
  },
  indexAxis: "y",
  layout: {
    padding: 10,
  },
};

function MunicipalCouncilSmallCommune({ data, langId }) {
  const labels = data.map(
    (item) =>
      `${capitalizeWords(item.candidate)} (${
        item.status === "elected"
          ? locales[langId].isElected
          : locales[langId].isNotElected
      })`
  );
  const dataObj = data.map((item) => item.votes);

  const chartData = {
    labels,
    datasets: [
      {
        label: locales[langId].numberOfVotes,
        data: dataObj,
        backgroundColor: "#86CDEB",
      },
    ],
  };

  return <Bar options={options} data={chartData} />;
}

export default MunicipalCouncilSmallCommune;
